import { toast } from 'react-toastify';
import API from 'api/API';
import { DeviceResponse, DeviceStatus } from 'api/Responses/DeviceResponses';

export type DeviceAction = 'save' | 'delete' | 'merge' | 'submit';

export const deviceActionSuccess: Record<DeviceAction, string> = {
  save: 'Device saved',
  submit: 'Device submitted for review',
  merge: 'Device merged',
  delete: 'Draft deleted',
};

export const deviceValidate = (device: DeviceResponse): void => {
  if (device.id === '') {
    throw new Error('Device code cannot be empty');
  }
};

export const deviceActionSwitch = async (action: DeviceAction, device: DeviceResponse): Promise<void> => {
  switch (action) {
    case 'save':
      await API.device.update(device);
      break;
    case 'delete':
      await API.device.remove(device.id);
      break;
    case 'submit':
      await API.device.update(device);
      await API.device.submit(device.id, DeviceStatus.PENDING);
      break;
    case 'merge':
      await API.device.update(device);
      await API.device.merge(device.id);
      break;
  }

  toast.success(deviceActionSuccess[action]);
};

export const generateFilePath = (deviceId: string, fileName: string): string => {
  return `part_diagrams/${deviceId}_${fileName}`;
};
